export default __webpack_public_path__ + "static/media/photoshoped-video.52fac158.png";